import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAreaUnit } from '../../../../utils/functions/countryUtils';

type SeedBag = {
  batchNumber: string;
  coveredAreaInAcres: string;
};

type SeedGroup = {
  label: string;
  bags: SeedBag[];
};

const ParentSeedData: React.FC<{ parentSeedData: any }> = ({
  parentSeedData,
}) => {
  const areaUnit = useAreaUnit();
  const [expanded, setExpanded] = useState<string | false>(
    'female'
  );

  const handleChange =
    (panel: string) =>
    (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const groups: SeedGroup[] = parentSeedData
    ? [
        {
          label: 'Female Seed',
          bags: parentSeedData.femaleSeedList || [],
        },
        {
          label: 'Male Seed',
          bags: parentSeedData.maleSeedList || [],
        },
      ]
    : [];

  return (
    <Box
      sx={{
        maxWidth: 500,
        bgcolor: 'white',
      }}>
      {/* Header */}

      {/* Accordion Groups */}
      <Box sx={{ px: 2, pb: 1 }}>
        {groups.map((group, idx) => {
          const key = group.label
            .toLowerCase()
            .includes('female')
            ? 'female'
            : 'male';
          return (
            <Accordion
              key={idx}
              expanded={expanded === key}
              onChange={handleChange(key)}
              disableGutters
              elevation={0}
              sx={{
                '&:before': { display: 'none' },
                boxShadow: 'none',
                borderBottom: '1px solid #E5E7EB',
              }}>
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={{ color: '#111827' }}
                  />
                }
                sx={{
                  px: 0,
                  py: 0.5,
                  minHeight: 40,
                  '& .MuiAccordionSummary-content': {
                    margin: 0,
                  },
                }}>
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: '#111827',
                  }}>
                  ▼ {group.label} ({group.bags.length})
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 0, py: 0.5 }}>
                {group.bags.length === 0 ? (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: 12,
                      fontStyle: 'italic',
                      py: 1,
                    }}>
                    No bags available
                  </Typography>
                ) : (
                  group.bags.map((bag, i) => (
                    <React.Fragment key={i}>
                      <Box
                        sx={{
                          display: 'flex',
                          // justifyContent: 'space-between',
                          alignItems: 'center',
                          py: 1,
                        }}>
                        <Typography
                          fontSize={12}
                          sx={{
                            fontStyle: 'italic',
                            color: 'rgba(77, 77, 77, 1)',
                            minWidth: 60,
                          }}>
                          Bag {i + 1}
                        </Typography>

                        <Typography
                          fontSize={13}
                          fontWeight={'bold'}
                          sx={{
                            color: 'rgba(0, 0, 0, 0.9)',
                            //minWidth: 70,
                          }}>
                          {bag.coveredAreaInAcres}
                        </Typography>

                        <Typography
                          fontSize={13}
                          fontWeight={400}
                          sx={{
                            color: 'rgba(0, 0, 0, 0.7)',
                            //  minWidth: 70,
                            marginLeft: 1,
                          }}>
                          {areaUnit}
                        </Typography>

                        <span
                          style={{
                            marginLeft: 10,
                            marginRight: 10,

                            color: 'rgba(217, 217, 217, 1)',
                          }}>
                          {' '}
                          •
                        </span>
                        <Typography
                          fontSize={13}
                          fontWeight={'bold'}
                          sx={{
                            color: 'rgba(0, 0, 0, 0.9)',
                          }}>
                          {bag?.batchNumber}
                        </Typography>
                      </Box>
                      {i < group.bags.length - 1 && (
                        <Divider
                          sx={{ borderColor: '#E5E7EB' }}
                        />
                      )}
                    </React.Fragment>
                  ))
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Box>
  );
};

export default ParentSeedData;
